import { render, staticRenderFns } from "./BackBarDrinksSection.vue?vue&type=template&id=6fc22c90&scoped=true"
import script from "./BackBarDrinksSection.vue?vue&type=script&lang=ts"
export * from "./BackBarDrinksSection.vue?vue&type=script&lang=ts"
import style0 from "./BackBarDrinksSection.vue?vue&type=style&index=0&id=6fc22c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc22c90",
  null
  
)

export default component.exports